const BREAKPOINT_DESKTOP_MIN = 1024;
const BREAKPOINT_DESKTOP_MAX = 1366;

export const isCompactDesktop = (width: number): boolean => {
  return width >= BREAKPOINT_DESKTOP_MIN && width < BREAKPOINT_DESKTOP_MAX;
};
